var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.737 1.27A1.455 1.455 0 0 0 10.684.25C9.74 0 6.01 0 6.01 0S2.26 0 1.316.25C.812.375.395.77.263 1.27 0 2.147 0 4.02 0 4.02s0 1.855.263 2.75c.132.5.549.876 1.053 1C2.26 8 6.011 8 6.011 8s3.73 0 4.673-.23c.504-.124.921-.5 1.053-1C12 5.876 12 4.02 12 4.02s0-1.874-.263-2.75ZM4.782 5.709V2.333l3.116 1.688-3.116 1.687Z",
    fill: "#151515"
  })));
};
export default SvgYoutube;